import React from "react";

export default function BrugesHamburger({ open, label = "" }) {
  return (
    <div
      className="relative h-[36px] w-[36px] select-none"
      aria-hidden="true"
      role="img"
      aria-label={label}
    >
      <i className="absolute left-1/2 top-1/2 h-[4px] w-[4px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-opacity duration-300" />

      <div
        className={`absolute inset-0 flex flex-col justify-between py-[1px] transition-all duration-300 ease-out ${
          open ? "scale-95 opacity-0" : "scale-100 opacity-100"
        }`}
      >
        <div className="grid grid-cols-[60%_auto_auto] items-center px-[1px]">
          <span className="h-[4px] w-full rounded-full bg-white" />
          <i className="h-[4px] w-[4px] justify-self-center rounded-full bg-white" />
          <i className="h-[4px] w-[4px] justify-self-end rounded-full bg-white" />
        </div>

        <div className="grid grid-cols-[40%_auto_40%] items-center px-[1px]">
          <span className="h-[4px] w-full rounded-full bg-white" />
          <span />
          <span className="h-[4px] w-full justify-self-end rounded-full bg-white" />
        </div>

        <div className="grid grid-cols-[auto_auto_60%] items-center px-[1px]">
          <i className="h-[4px] w-[4px] justify-self-start rounded-full bg-white" />
          <i className="h-[4px] w-[4px] justify-self-center rounded-full bg-white" />
          <span className="h-[4px] w-full justify-self-end rounded-full bg-white" />
        </div>
      </div>

      <span
        className={`absolute left-1/2 top-1/2 h-[4px] w-[16px] origin-left -translate-y-1/2 rotate-45 rounded-full bg-white transition-all duration-300 ease-out ${
          open ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0"
        }`}
      />
      <span
        className={`absolute left-1/2 top-1/2 h-[4px] w-[16px] origin-left -translate-y-1/2 -rotate-45 rounded-full bg-white transition-all duration-300 ease-out ${
          open ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0"
        }`}
      />
      <span
        className={`absolute left-1/2 top-1/2 h-[4px] w-[16px] origin-right -translate-x-full -translate-y-1/2 -rotate-45 rounded-full bg-white transition-all duration-300 ease-out ${
          open ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0"
        }`}
      />
      <span
        className={`absolute left-1/2 top-1/2 h-[4px] w-[16px] origin-right -translate-x-full -translate-y-1/2 rotate-45 rounded-full bg-white transition-all duration-300 ease-out ${
          open ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0"
        }`}
      />
    </div>
  );
}